// AutoMapper
import { AutoMap } from '@nartc/automapper';

export class CountryDto {
    @AutoMap() createdBy: string;
    @AutoMap() createdDate: string;
    @AutoMap() id: string;
    @AutoMap() inactive: boolean = false;
    @AutoMap() iso3Code: string;
    @AutoMap() lastModifiedBy: string;
    @AutoMap() lastModifiedDate: string;
    @AutoMap() localizableEntryId: string;
    @AutoMap() name: string;
    @AutoMap() timeStamp: string;

    constructor() { }
}